(function () {
    'use strict';

    angular.module('sa.directives').directive('smartMenu', ['$rootScope', '$timeout', function ($rootScope, $timeout) {
        var directive = {
            restrict: 'A',
            link: link
        };
        return directive;

        function link(scope, element, attrs) {

            $timeout(function () {
                var $body = $('body');
                var $collapsible = element.find('li[data-menu-collapse]');
                $collapsible.each(function (idx, li) {
                    var $li = $(li);
                    $li.on('click', '>a', function (e) {
                        // collapse all open siblings
                        smartCollapseToggle($li.siblings('.open'));

                        // toggle element
                        smartCollapseToggle($li);

                        // add active marker to collapsed element if it has active childs
                        if (!$li.hasClass('open') && $li.find('li.active').length > 0) {
                            $li.addClass('active')
                        }

                        e.preventDefault();
                    }).find('>a').append('<b class="collapse-sign"><em class="fa fa-plus-square-o"></em></b>');

                    // initialization toggle
                    if ($li.find('li.active').length) {
                        smartCollapseToggle($li);
                        $li.find('li.active').parents('li').addClass('active');
                    }
                });

                element.find('> li').addClass('smart-menu-li');

                element.on('click', 'a[data-ui-sref]', smartMenuItemClick);
            });
        }

        function smartCollapseToggle(elements) {
            return elements.each(function () {
                var $body = $('body');
                var $this = $(this);

                // exit if 'menu-on-top'
                if ($body.hasClass('menu-on-top'))
                    return;

                $body.hasClass('mobile-view-activated')

                // toggle open
                $this.toggleClass('open');

                // for minified menu collapse only second level
                if ($body.hasClass('minified')) {
                    if ($this.closest('nav ul ul').length) {
                        $this.find('>a .collapse-sign .fa').toggleClass('fa-minus-square-o fa-plus-square-o');
                        $this.find('ul:first').slideToggle(appConfig.menu_speed || 200);
                    }
                } else {
                    // toggle expand item
                    $this.find('>a .collapse-sign .fa').toggleClass('fa-minus-square-o fa-plus-square-o');
                    $this.find('ul:first').slideToggle(appConfig.menu_speed || 200);
                }
            });
        }

        function smartMenuItemClick(e) {
            var $body = $('body');

            var li = $(this).parent('li');
            var selectedParent = li.hasClass('smart-menu-li') ? $(this) : $(this).closest('.smart-menu-li');

            // Find all parent lis and their children and remove their active status
            $body.find('.smart-menu-li').not(selectedParent).each(function () {
                $(this).removeClass('active');
                $(this).find('li.active').removeClass('active');
                if($(this).hasClass('open'))
                    smartCollapseToggle($(this));
            });

            // If the clicked item is a dropdown don't set it as active
            var isParent = li.has('li').length;
            if (!isParent) {
                li.addClass('active');
                li.siblings().removeClass('active');
            }

            if ($body.hasClass('mobile-view-activated')) {
                $rootScope.$broadcast('requestToggleMenu');
            }
        }
    }]);

})();